import React from 'react'
// import Globlex from "src/components/Logo/brokers/Globlex";

export const brokerList = [
  {
    brokerID : process.env.REACT_APP_BROKER_ID || "ENV",
    brokerName : process.env.REACT_APP_BROKER_NAME || "ENV",
    icon : (
      <img
          alt="stt"
          src="/static/brokers/globlexColorShort.svg"
          style={{maxHeight:40}}
      />
    ),
  },
]
